// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).ready(function () {
    if ($('.gallery-grid').length) {
        let photos = $('.photo');

        $.each(photos, function (i, val) {
            let photoArea = val.classList[1].split('-')[1];

            $(val).css('grid-area', String.fromCharCode(parseInt(photoArea) + 96));
        });
    }
});

$(document).on('scroll', function () {
    $('.animate').not('.run').each(function () {
        if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run')
    })
}).trigger('scroll')
